package fr.manyverse.app.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.infrastructure.datastore.UserPreferencesDataStore
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class ThemeViewModel(
    private val _selectedUniverse: MutableStateFlow<Universe?>,
    private val userPreferencesDataStore: UserPreferencesDataStore
) : ViewModel() {

    private val _isDarkTheme = MutableStateFlow<Boolean?>(null)
    val isDarkTheme: StateFlow<Boolean?> = _isDarkTheme.asStateFlow()

    val selectedUniverse: StateFlow<Universe?> = _selectedUniverse.asStateFlow()

    val universeId: String?
        get() = _selectedUniverse.value?.id

    init {
        viewModelScope.launch {
            _isDarkTheme.value = userPreferencesDataStore.getThemePreference()
        }
    }

    fun toggleTheme(currentSystemTheme: Boolean) {
        val newValue = when (_isDarkTheme.value) {
            null -> !currentSystemTheme
            true -> false
            false -> true
        }
        _isDarkTheme.value = newValue
        viewModelScope.launch { userPreferencesDataStore.saveThemePreference(newValue) }
    }

    fun useSystemTheme() {
        _isDarkTheme.value = null
        viewModelScope.launch { userPreferencesDataStore.saveThemePreference(null) }
    }

    fun setDarkTheme(isDark: Boolean) {
        _isDarkTheme.value = isDark
        viewModelScope.launch { userPreferencesDataStore.saveThemePreference(isDark) }
    }

    fun selectUniverse(universe: Universe) {
        _selectedUniverse.value = universe
    }

    fun clearUniverse() {
        _selectedUniverse.value = null
    }
}
